import React, { useState, useEffect } from "react";
import { TextField, MenuItem, Button, Chip, Box, Grid } from "@mui/material";

const languages = ["İngilizce", "Türkçe", "Almanca", "Fransızca", "İspanyolca"];
const levels = ["Başlangıç", "Orta", "İyi"];

const LanguageSelector = ({ formValues, setFormValues }) => {
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [newLanguage, setNewLanguage] = useState("");
  const [newLevel, setNewLevel] = useState("");
  const [customLanguage, setCustomLanguage] = useState("");

  // Bu useEffect yalnızca başlangıçta formValues.languages'i alır
  useEffect(() => {
    // Eğer formValues.languages bir stringse
    if (typeof formValues.languages === 'string') {
      // Virgülle ayırarak dil ve seviyeleri işleme alıyoruz
      const languagesArray = formValues.languages.split(',').map((item) => {
        const [language, level] = item.split(".");
        return { language, level };
      });
      setSelectedLanguages(languagesArray);
    } else if (Array.isArray(formValues.languages)) {
      // Eğer formValues.languages zaten bir dizi ise
      const languagesArray = formValues.languages.map((item) => {
        const [language, level] = item.split(".");
        return { language, level };
      });
      setSelectedLanguages(languagesArray);
    } else {
      setSelectedLanguages([]); // Eğer hiçbiri değilse, boş bir dizi atıyoruz
    }
  }, [formValues.languages]);
  

  const addLanguage = (updatedLanguages) => {
    setFormValues((prev) => ({
      ...prev,
      languages: updatedLanguages.map(({ language, level }) => `${language}.${level}`)
    }));
  };

  const handleAddLanguage = () => {
    if (newLanguage && newLevel) {
      const updatedLanguages = [
        ...selectedLanguages,
        { language: newLanguage, level: newLevel }
      ];
      setSelectedLanguages(updatedLanguages);
      addLanguage(updatedLanguages);
      console.log(updatedLanguages); // Güncellenmiş dizi burada
      setNewLanguage("");
      setNewLevel("");
    }
  };

  const handleAddCustomLanguage = () => {
    if (customLanguage && newLevel) {
      const updatedLanguages = [
        ...selectedLanguages,
        { language: customLanguage, level: newLevel }
      ];
      setSelectedLanguages(updatedLanguages);
      addLanguage(updatedLanguages);
      setCustomLanguage("");
      setNewLevel("");
    }
  };

  const handleDelete = (index) => {
    const updatedLanguages = selectedLanguages.filter((_, i) => i !== index);
    setSelectedLanguages(updatedLanguages);
    addLanguage(updatedLanguages);
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} width={400}>
      <TextField label="Seçilenler" value={selectedLanguages.map(({ language, level }) => `${language} - ${level}`).join(",")} fullWidth disabled />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            select
            label="Dil Seç"
            value={newLanguage}
            onChange={(e) => setNewLanguage(e.target.value)}
            fullWidth
          >
            {languages.map((lang) => (
              <MenuItem key={lang} value={lang}>
                {lang}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={6}>
          <TextField
            select
            label="Seviye Seç"
            value={newLevel}
            onChange={(e) => setNewLevel(e.target.value)}
            fullWidth
          >
            {levels.map((level) => (
              <MenuItem key={level} value={level}>
                {level}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      <Button variant="contained" onClick={handleAddLanguage} disabled={!newLanguage || !newLevel}>
        Ekle
      </Button>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            label="Diğer (Eğer listede yoksa)"
            value={customLanguage}
            onChange={(e) => setCustomLanguage(e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            select
            label="Seviye Seç"
            value={newLevel}
            onChange={(e) => setNewLevel(e.target.value)}
            fullWidth
          >
            {levels.map((level) => (
              <MenuItem key={level} value={level}>
                {level}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      <Button variant="contained" onClick={handleAddCustomLanguage} disabled={!customLanguage || !newLevel}>
        Ekle
      </Button>

      <Box display="flex" flexWrap="wrap" gap={1}>
        {selectedLanguages.map(({ language, level }, index) => (
          <Chip key={index} label={`${language} - ${level}`} onDelete={() => handleDelete(index)} size="small" />
        ))}
      </Box>
    </Box>
  );
};

export default LanguageSelector;
